module.exports = __webpack_public_path__ + "img/bitbox02-welcome.1afcb9b8.jpg";